import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemCategory\GetItemCategoryByIdController::__invoke
* @see app/Http/Controllers/ItemCategory/GetItemCategoryByIdController.php
* @route '/api/item-category/{itemCategory}'
*/
const GetItemCategoryByIdController = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemCategoryByIdController.url(args, options),
    method: 'get',
})

GetItemCategoryByIdController.definition = {
    methods: ["get","head"],
    url: '/api/item-category/{itemCategory}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemCategory\GetItemCategoryByIdController::__invoke
* @see app/Http/Controllers/ItemCategory/GetItemCategoryByIdController.php
* @route '/api/item-category/{itemCategory}'
*/
GetItemCategoryByIdController.url = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { itemCategory: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { itemCategory: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            itemCategory: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        itemCategory: typeof args.itemCategory === 'object'
        ? args.itemCategory.id
        : args.itemCategory,
    }

    return GetItemCategoryByIdController.definition.url
            .replace('{itemCategory}', parsedArgs.itemCategory.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemCategory\GetItemCategoryByIdController::__invoke
* @see app/Http/Controllers/ItemCategory/GetItemCategoryByIdController.php
* @route '/api/item-category/{itemCategory}'
*/
GetItemCategoryByIdController.get = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemCategoryByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemCategory\GetItemCategoryByIdController::__invoke
* @see app/Http/Controllers/ItemCategory/GetItemCategoryByIdController.php
* @route '/api/item-category/{itemCategory}'
*/
GetItemCategoryByIdController.head = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemCategoryByIdController.url(args, options),
    method: 'head',
})

export default GetItemCategoryByIdController